import React, { useEffect, useState } from 'react';

import { PerfVsIndexCapsuleConfigState } from '../store/config/PerfVsIndexCapsuleConfigState';
import ReactCardFlip from 'react-card-flip';
import { PerfVsIndexCapsuleChart } from './chart/PerfVsIndexCapsuleChart';
import { PerfVsIndexCapsuleValues } from './values/PerfVsIndexCapsuleValues';
import { PerfVsIndexData } from 'widgets/perfVsIndexCapsule/perfVsIndexCapsuleData';
import WidgetSettingsButton from 'widgets/WidgetToolbar/WidgetSettingsButton';
import PerfVsIndexCapsuleSettings, {
    PerfVsIndexCapsuleSettingsText,
} from 'widgets/perfVsIndexCapsule/components/settings/PerfVsIndexCapsuleSettings';
import InfoBox from 'utils/components/InfoBox/InfoBox';

import './PerfVsIndexCapsuleContent.scss';

interface PerfVsIndexCapsuleContentProps {
    symbol?: string;
    index: string;
    capsuleKey: string;
    data?: PerfVsIndexData;
    config: PerfVsIndexCapsuleConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<PerfVsIndexCapsuleConfigState>
    ) => void;
}
export function PerfVsIndexCapsuleContent(
    props: PerfVsIndexCapsuleContentProps
) {
    const { config, index, dispatchConfigChanged, symbol, capsuleKey, data } =
        props;
    const { view, showIndexPerf } = config;

    const [time, setTime] = useState<number | undefined>();

    useEffect(() => {
        setTime(undefined);
    }, [symbol]);

    const isFlipped = view === 'values';

    if (!data) {
        return <div className="PerfVsIndexCapsuleContent">No data</div>;
    }

    if (index?.length < 1) {
        return (
            <div className="PerfVsIndexCapsuleContent">
                <InfoBox
                    className="choose-index-box"
                    info={
                        <WidgetSettingsButton
                            header={PerfVsIndexCapsuleSettingsText}
                            triggerText="Configure Index Mappings"
                            body={<PerfVsIndexCapsuleSettings />}
                        />
                    }
                />
            </div>
        );
    }

    const onChartClick = (nextTime?: number) => {
        setTime(nextTime);
        if (nextTime !== undefined) {
            dispatchConfigChanged({ view: 'values' });
        }
    };

    return (
        <div className="PerfVsIndexCapsuleContent">
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <PerfVsIndexCapsuleChart
                    key="front"
                    data={data}
                    onClick={onChartClick}
                    chartKey={capsuleKey}
                    showIndexPerf={!!showIndexPerf}
                />
                <PerfVsIndexCapsuleValues
                    key="back"
                    data={data}
                    index={index}
                    time={time}
                    onClick={() => dispatchConfigChanged({ view: 'chart' })}
                />
            </ReactCardFlip>
        </div>
    );
}
